import { Lightning, Utils } from "@lightningjs/sdk";
import { PLAYER_DARK, PLAYER_PINK, playerText } from "./styles";
const TRANSITION = { duration: 0.25, timingFunction: "ease-out" };
const PANEL_Y = 338;
const ENTER_OFFSET = 18;
const asset = (name) => Utils.asset(`images/player/stats-${name}`);
const svg = (name, w, h) => ({
    w,
    h,
    texture: Lightning.Tools.getSvgTexture(asset(name), Math.ceil(w * 2), Math.ceil(h * 2)),
});
/** The Figma stats QR panel, displayed over continuing live playback. */
export class GameStats extends Lightning.Component {
    static _template() {
        return {
            w: 1920,
            h: 1080,
            alpha: 0,
            Shade: {
                y: 547,
                w: 1920,
                h: 533,
                rect: true,
                colorTop: 0x00161616,
                colorBottom: PLAYER_DARK,
            },
            Panel: {
                x: 1202,
                y: PANEL_Y + ENTER_OFFSET,
                w: 719,
                h: 403,
                Fill: {
                    w: 719,
                    h: 403,
                    rect: true,
                    shader: {
                        type: Lightning.shaders.RoundedRectangle,
                        radius: [20, 0, 0, 20],
                        fillColor: 0xcc161616,
                    },
                },
                Background: Object.assign(Object.assign({}, svg("panel.svg", 719, 403)), { shader: {
                        type: Lightning.shaders.RoundedRectangle,
                        radius: [20, 0, 0, 20],
                    } }),
                Border: {
                    w: 719,
                    h: 403,
                    texture: Lightning.Tools.getCanvasTexture((callback) => {
                        const canvas = document.createElement("canvas");
                        canvas.width = 1438;
                        canvas.height = 806;
                        const context = canvas.getContext("2d");
                        context.scale(2, 2);
                        const gradient = context.createLinearGradient(0, 0, 0, 403);
                        gradient.addColorStop(0, "rgba(255,255,255,0.5)");
                        gradient.addColorStop(0.5, "rgba(255,255,255,0)");
                        gradient.addColorStop(1, "rgba(255,255,255,0.5)");
                        context.strokeStyle = gradient;
                        context.lineWidth = 1;
                        context.beginPath();
                        context.moveTo(20, 0.5);
                        context.lineTo(718.5, 0.5);
                        context.lineTo(718.5, 402.5);
                        context.lineTo(20, 402.5);
                        context.arcTo(0.5, 402.5, 0.5, 382.5, 19.5);
                        context.lineTo(0.5, 20);
                        context.arcTo(0.5, 0.5, 20, 0.5, 19.5);
                        context.closePath();
                        context.stroke();
                        callback(null, canvas);
                    }, "live-stats-panel-border"),
                },
                Header: {
                    x: 202,
                    y: -17,
                    w: 315,
                    h: 33,
                    Background: {
                        w: 315,
                        h: 33,
                        rect: true,
                        color: PLAYER_PINK,
                        shader: { type: Lightning.shaders.RoundedRectangle, radius: 8 },
                    },
                    Label: {
                        text: Object.assign(Object.assign({}, playerText("SCAN QR CODE", 28, 33)), { w: 315, textAlign: "center", textColor: PLAYER_DARK }),
                    },
                },
                Teams: {
                    x: 117,
                    y: 39,
                    w: 486,
                    h: 70,
                    Home: { w: 144, h: 70, src: asset("psg.png") },
                    Away: {
                        x: 338,
                        w: 148,
                        h: 70,
                        clipping: true,
                        Logo: Object.assign({ x: 14, y: -25 }, svg("marseille.svg", 120, 120)),
                    },
                    Competition: Object.assign({ x: 144, y: 0.965 }, svg("competition.svg", 194, 68.07)),
                },
                Intro: {
                    x: 152.7,
                    y: 178.3,
                    text: {
                        text: "CHECK",
                        fontFace: "Roboto Condensed",
                        fontStyle: "400",
                        fontSize: 25,
                        precision: 1,
                        offsetY: 25,
                        lineHeight: 32.225,
                        h: 32.225,
                        textColor: 0xffffffff,
                        wordWrap: false,
                    },
                },
                Title: { x: 152.7, y: 197.4, text: playerText("LIVE STATS", 55) },
                QrCode: {
                    x: 410,
                    y: 141.064,
                    w: 157,
                    h: 157,
                    src: asset("qr.png"),
                    shader: { type: Lightning.shaders.RoundedRectangle, radius: 8 },
                },
                Sponsors: {
                    x: 294.163,
                    y: 330,
                    w: 131.674,
                    h: 34,
                    Ligue1: {
                        w: 96.56,
                        h: 34,
                        texture: Lightning.Tools.getSvgTexture(Utils.asset("images/navbar/ligue-1-plus.svg"), 194, 68),
                    },
                    McDonalds: Object.assign({ x: 105.834, y: 5.695 }, svg("mcdonalds.svg", 25.84, 22.61)),
                },
            },
        };
    }
    open() {
        this.setSmooth("alpha", 1, TRANSITION);
        this.tag("Panel").setSmooth("y", PANEL_Y, TRANSITION);
    }
    close(animate = true) {
        var _a, _b;
        if (animate) {
            this.setSmooth("alpha", 0, TRANSITION);
            this.tag("Panel").setSmooth("y", PANEL_Y + ENTER_OFFSET, TRANSITION);
        }
        else {
            (_a = this.transition("alpha")) === null || _a === void 0 ? void 0 : _a.stop();
            (_b = this.tag("Panel").transition("y")) === null || _b === void 0 ? void 0 : _b.stop();
            this.patch({ alpha: 0, Panel: { y: PANEL_Y + ENTER_OFFSET } });
        }
    }
    _handleKey() {
        return true;
    }
    _handleKeyRelease() {
        return true;
    }
    _handleBack() {
        return true;
    }
    _handleBackRelease() {
        this.signal("close");
        return true;
    }
}
export default GameStats;
//# sourceMappingURL=GameStats.js.map